import React from 'react';
import TaskTourOverlay from './TaskTourOverlay';
import WelcomeModal from './WelcomeModal';

/**
 * Mounts the first-run + on-demand tour surfaces. Content is gated on
 * the tour context state, so this is cheap to keep in the layout tree.
 * Place once inside <MoopLayout> under <OnboardingTourProvider>.
 *
 * The Help-nav spot lives inside <MoopSider>, not here — it's positioned
 * relative to the sidebar item so it stays put through page transitions.
 */
const OnboardingTourRoot: React.FC = () => (
  <>
    <WelcomeModal />
    <TaskTourOverlay />
  </>
);

export default OnboardingTourRoot;
